import D2C_TariffStarter from './Starter'

class D2C_TariffStarterAnnual extends D2C_TariffStarter {
  isAnnual = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '5f731985b62b534e37ef5bf4'
  static tariffTitle = 'Starter annual'
  static order = 16
}

export default D2C_TariffStarterAnnual
